var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M160 89c39,0 71,32 71,71 0,39 -32,71 -71,71 -39,0 -71,-32 -71,-71 0,-39 32,-71 71,-71z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160 320c15,0 29,-2 43,-6 13,-4 26,-9 38,-16 12,-7 22,-15 32,-25 10,-10 18,-20 25,-32 7,-12 12,-25 16,-38 4,-14 6,-28 6,-43 0,-15 -2,-29 -6,-43 -4,-13 -9,-26 -16,-38 -7,-12 -15,-22 -25,-32 -10,-10 -20,-18 -32,-25 -12,-7 -25,-12 -38,-16 -14,-4 -28,-6 -43,-6 -15,0 -29,2 -43,6 -13,4 -26,9 -38,16 -12,7 -22,15 -32,25 -10,10 -18,20 -25,32 -7,12 -12,25 -16,38 -4,14 -6,28 -6,43 0,15 2,29 6,43 4,13 9,26 16,38 7,12 15,22 25,32 10,10 20,18 32,25 12,7 25,12 38,16 14,4 28,6 43,6zm0 -300l0 0c13,0 25,2 37,5 12,3 23,8 34,14 10,6 19,14 28,22 8,9 16,18 22,28 6,11 11,22 14,34 3,12 5,24 5,37 0,13 -2,25 -5,37 -3,12 -8,23 -14,34 -6,10 -14,19 -22,28 -9,8 -18,16 -28,22 -11,6 -22,11 -34,14 -12,3 -24,5 -37,5 -13,0 -25,-2 -37,-5 -12,-3 -23,-8 -34,-14 -10,-6 -19,-14 -28,-22 -8,-9 -16,-18 -22,-28 -6,-11 -11,-22 -14,-34 -3,-12 -5,-24 -5,-37 0,-13 2,-25 5,-37 3,-12 8,-23 14,-34 6,-10 14,-19 22,-28 9,-8 18,-16 28,-22 11,-6 22,-11 34,-14 12,-3 24,-5 37,-5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.fff73d88.svg";
export { ForwardRef as ReactComponent };